module.exports = __webpack_public_path__ + "static/media/avataaars.0f5582ee.svg";